import script from "./TermsAndConditionsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./TermsAndConditionsModal.vue?vue&type=script&setup=true&lang=js"

import "./TermsAndConditionsModal.vue?vue&type=style&index=0&id=d810ab70&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d810ab70"]])

export default __exports__